import { Button, Tooltip, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { useMemo } from 'react';
import { defaultFacTab } from './InitialDueDiligenceView';
import { buttonStyle } from '../TransitionStyles';
import Iconify from '../../../../reusable-components/iconify';

FacilityActions.propTypes = {
  isAdmin: PropTypes.bool,
  setPortfolio: PropTypes.func,
  isAddingFac: PropTypes.bool,
  setIsAddingFacility: PropTypes.func,
};
export default function FacilityActions({ isAdmin, setPortfolio, setIsAddingFacility, isAddingFac }) {
  const navigate = useNavigate();
  const {
    formState: { isDirty },
    watch,
  } = useFormContext();
  const watching = watch();
  const {
    data: { defaultFacility, isCanceled },
  } = useSelector((state) => state.transitions);
  const { id } = useParams();

  const handleAppendFacility = async () => {
    setIsAddingFacility(true);
    navigate(`/dashboard/transitions/initial-due-diligence/${id}?facilityId=${0}`, { replace: true });

    setPortfolio((prev) => ({
      ...prev,
      facilityFields: defaultFacility,
      facilityTabs: [...prev.facilityTabs, defaultFacTab],
    }));
  };

  const areRequiredFieldsFilled = useMemo(
    () => !!(watching.facilityName && watching.portfolioName && watching.companyId),
    [watching]
  );

  const AddFacilityButton = () => (
    <Tooltip
      title={
        id === '0' || id == null
          ? 'Save new portfolio to add a facility'
          : isAddingFac
            ? 'Save or delete the new facility to add a facility'
            : isDirty
              ? 'Save changes to add a facility'
              : ''
      }
      placement="bottom"
      arrow
      disableHoverListener={!isAddingFac && !isDirty && areRequiredFieldsFilled}
    >
      <span>
        <Button
          color="secondary"
          variant="outlined"
          onClick={handleAppendFacility}
          disabled={!areRequiredFieldsFilled || isDirty || isCanceled}
          fullWidth
          sx={{ ...buttonStyle, mt: 2 }}
          startIcon={<Iconify icon="eva:plus-outline" />}
        >
          Add Facility
        </Button>
      </span>
    </Tooltip>
  );

  return (
    <Grid item>
      {isAdmin && (
        <span style={{ width: '100%' }}>
          <AddFacilityButton />
        </span>
      )}
    </Grid>
  );
}
